import AjaxRequest from '../AjaxRequest';
import CallbackHandler from '../CallbackHandler';
import AxiosRequest from '../AxiosRequest';


export default class Bases {
    constructor() {
        this.output = [];
    }

    async get(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.getRequest().then(function (response) {
            if (response.status === 200) {
                //return self.output = callback.handleSuccess(response.data, 'output');
                return self.output = response
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.output = 'An error has occurred, please try again';
            }
        })
    }

    async post(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.postRequest().then(function (response) {
            if (response.status === 200) {
                //return self.output = callback.handleSuccess(response.data, 'output');
                return response
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.output = 'An error has occurred, please try again';
            }
        })
    }

    async index() {
        await this.get(`military/bases`, null, 'military/bases', "Error. Please refresh and try again.");
        return this.output;
    }

    async deleteGraduationDate(baseId, dateId) {
        return new AxiosRequest().delete(`military/bases/${baseId}/graduation-dates/${dateId}`);
    }

    async getUserBases(data) {
        return new AxiosRequest().get(`military/bases/userBases`, data);
    }

    async updateUserBases(data) {
        return new AxiosRequest().post(`military/bases/userBases`, data);
    }

    async getGraduationDateList(baseId) {
        return await new AxiosRequest().get(`military/bases/${baseId}/graduation-dates`);
    }

    async saveGraduationDate(baseId, data) {
        return await new AxiosRequest().post(`military/bases/${baseId}/graduation-dates`, data);
    }

    async updateGraduationDate(baseId, dateId, data) {
        return await new AxiosRequest().patch(`military/bases/${baseId}/graduation-dates/${dateId}`, data);
    }

    async getBaseDetails(baseId) {
        return await new AxiosRequest().get(`military/bases/${baseId}`);
    }

    /**
     * Platoon/Company/Squadron
     * @param baseId
     * @returns {Promise<* | T>}
     */
    async getGroup(baseId) {
        return await new AxiosRequest().get(`military/bases/${baseId}/groups`);
    }

    /**
     * Flight/Battalion/Unit
     * @param baseId
     * @returns {Promise<* | T>}
     */
    async getSubGroup(baseId) {
        return await new AxiosRequest().get(`military/bases/${baseId}/subgroups`);
    }
}
